import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class DeiService {

  private api_url = CONFIGURATION.baseServiceUrl + 'die-report/';
  private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

  constructor(private _http: Http) { }

  getReferenceData(data:any){
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'reference-data', data, {headers:headers})
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }
  referencedata(data:any):Observable<any>{
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'reference-data', data, {headers:headers})
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }
  reportData(data:any) :Observable<any>{
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.api_url + `report-data?ControlGroup=${data.controlGroup}&Proudctioncompany=${data.productionCompany}&ProdShowName=${data.show}&StartDate=${data.startDate}&EndDate=${data.endDate}`, {headers:headers})
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }
  downloadExcel(filterCriteria:any) :Observable<any>{
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.api_url + 'excel-download?ControlGroup='+ filterCriteria.controlGroup + '&Proudctioncompany=' + filterCriteria.productionCompany + '&ProdShowName='+ filterCriteria.show + '&StartDate=' + filterCriteria.startDate + '&EndDate=' + filterCriteria.endDate, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
          const a = document.createElement('a');
          document.body.appendChild(a);
          const blob = new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl);
      })
  }
  downloadPDFReport(filterCriteria: any): any {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.api_url + 'pdf-download?ControlGroup='+ filterCriteria.controlGroup + '&Proudctioncompany=' + filterCriteria.productionCompany + '&ProdShowName='+ filterCriteria.show + '&StartDate=' + filterCriteria.startDate + '&EndDate=' + filterCriteria.endDate, { headers: headers, responseType: ResponseContentType.Blob }).map(
        (res) => {
            var link = document.createElement('a');
            let blob = new Blob([res.blob()], {
              type: 'application/pdf' // must match the Accept type
            });
            link.href = window.URL.createObjectURL(blob);
            link.download = `${filterCriteria.startDate}_${filterCriteria.endDate}_${filterCriteria.controlGroup}_${Date.now()}.pdf`;
            link.click();
            window.URL.revokeObjectURL(link.href);
        })
  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }

  getSSnData(ssnData: any): Observable<any[]> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
        + '&TaxYear=' + ssnData.taxyear
        + '&ControlGroup=' + ssnData.controlgroup
        + '&ReportName=' + 'PayDayFederalReport';
    return this._http.get(this._ssnUrl + fileName, { headers: headers })
        .map((response: Response) => response.json())
        .catch(this.handleError);
}
}



// WEBPACK FOOTER //
// ./src/app/dei/dei.service.ts